const FAWRY_CARD_CODE = 46688;
export default FAWRY_CARD_CODE;
